export default () => ({
	id: null,
	region: {},
	regions: [],
	filter: null,
	error: null,
});
